interface ReadProgressRingProps {
  progress: number; // 0–100
  color: string;
  size?: number;
  strokeWidth?: number;
}

const ReadProgressRing = ({ progress, color, size = 36, strokeWidth = 2.5 }: ReadProgressRingProps) => {
  const radius = (size - strokeWidth * 2) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (Math.min(progress, 100) / 100) * circumference;
  const pct = Math.round(progress);
  const isDone = pct >= 100;

  return (
    <div
      className="relative shrink-0 flex items-center justify-center"
      style={{ width: size, height: size }}
      role="progressbar"
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={`Прочитано ${pct}%`}
      title={`Прочитано ${pct}%`}
    >
      <svg
        width={size}
        height={size}
        style={{ transform: 'rotate(-90deg)' }}
      >
        {/* Track */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="rgba(255,255,255,0.07)"
          strokeWidth={strokeWidth}
        />
        {/* Progress arc */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={isDone ? '#39ff14' : color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{
            transition: 'stroke-dashoffset 0.3s ease, stroke 0.4s ease',
            filter: `drop-shadow(0 0 3px ${isDone ? '#39ff14' : color}80)`,
          }}
        />
      </svg>

      {/* Center label */}
      <div className="absolute inset-0 flex items-center justify-center">
        {isDone ? (
          <i
            className="ri-check-line"
            style={{ color: '#39ff14', fontSize: '13px', filter: 'drop-shadow(0 0 4px #39ff14)' }}
          />
        ) : (
          <span
            className="font-orbitron font-black leading-none"
            style={{ fontSize: '8px', color: pct > 0 ? color : 'rgba(255,255,255,0.2)' }}
          >
            {pct > 0 ? `${pct}%` : ''}
          </span>
        )}
      </div>
    </div>
  );
};

export default ReadProgressRing;
